/*
 * BSL — WOW.js-compatibele reveal op basis van IntersectionObserver.
 *
 * Vervangt wow.min.js (v1.2.1). Zelfde API (`new WOW(opties).init()`), zelfde
 * classes (`wow` / `animated`), data-attributen (data-wow-duration/-delay/
 * -iteration/-offset), `wow`-event en live-modus.
 *
 * Verschil: WOW.js las bij elke scroll (en elke 50 ms via setInterval) de
 * offsetTop van iedere box → forced layout tijdens scrollen = haperingen.
 * Deze versie doet tijdens het scrollen geen JS-werk; de browser meldt zelf
 * wanneer een box in beeld komt.
 */
(function (window, document) {
  'use strict';

  var raf = window.requestAnimationFrame
    ? function (cb) { window.requestAnimationFrame(cb); }
    : function (cb) { cb(); };

  function isMobile(ua) {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
  }

  function WOW(options) {
    options = options || {};
    this.config = {
      boxClass: options.boxClass != null ? options.boxClass : 'wow',
      animateClass: options.animateClass != null ? options.animateClass : 'animated',
      offset: options.offset != null ? options.offset : 0,
      mobile: options.mobile != null ? options.mobile : true,
      live: options.live != null ? options.live : true,
      callback: options.callback != null ? options.callback : null
    };
    this.tracked = typeof WeakSet === 'function' ? new WeakSet() : null;
    this.trackedList = [];
    this.names = typeof WeakMap === 'function' ? new WeakMap() : null;
    this.observers = {};
    this.stopped = true;
    this.start = this.start.bind(this);
    this.resetAnimation = this.resetAnimation.bind(this);
  }

  WOW.prototype.init = function () {
    this.element = document.documentElement;
    if (document.readyState === 'interactive' || document.readyState === 'complete') {
      this.start();
    } else {
      document.addEventListener('DOMContentLoaded', this.start);
    }
    return this;
  };

  WOW.prototype.disabled = function () {
    return !this.config.mobile && isMobile(navigator.userAgent);
  };

  WOW.prototype.start = function () {
    var self = this;
    this.stopped = false;

    var boxes = this.element.querySelectorAll('.' + this.config.boxClass);
    for (var i = 0; i < boxes.length; i++) this.track(boxes[i]);

    if (this.config.live && typeof MutationObserver === 'function' && document.body) {
      this.mutationObserver = new MutationObserver(function (records) {
        for (var r = 0; r < records.length; r++) {
          var added = records[r].addedNodes;
          for (var n = 0; n < added.length; n++) self.sync(added[n]);
        }
      });
      this.mutationObserver.observe(document.body, { childList: true, subtree: true });
    }
  };

  WOW.prototype.stop = function () {
    this.stopped = true;
    for (var key in this.observers) {
      if (Object.prototype.hasOwnProperty.call(this.observers, key)) this.observers[key].disconnect();
    }
    this.observers = {};
    if (this.mutationObserver) this.mutationObserver.disconnect();
  };

  /* Nieuwe .wow-elementen oppikken (live-modus / handmatig aanroepbaar). */
  WOW.prototype.sync = function (node) {
    node = node || this.element;
    if (!node || node.nodeType !== 1) return;
    var cls = this.config.boxClass;
    if (node.classList && node.classList.contains(cls)) this.track(node);
    var boxes = node.querySelectorAll('.' + cls);
    for (var i = 0; i < boxes.length; i++) this.track(boxes[i]);
  };

  WOW.prototype.isTracked = function (box) {
    return this.tracked ? this.tracked.has(box) : this.trackedList.indexOf(box) >= 0;
  };

  WOW.prototype.track = function (box) {
    if (this.isTracked(box)) return;
    if (this.tracked) this.tracked.add(box); else this.trackedList.push(box);

    // Geen IntersectionObserver of uitgeschakeld: nooit content verborgen laten.
    if (this.stopped || this.disabled() || typeof IntersectionObserver !== 'function') {
      box.style.visibility = 'visible';
      return;
    }
    this.applyStyle(box, true);
    this.observerFor(box.getAttribute('data-wow-offset') || this.config.offset).observe(box);
  };

  WOW.prototype.observerFor = function (offset) {
    offset = parseInt(offset, 10) || 0;
    if (this.observers[offset]) return this.observers[offset];
    var self = this;
    var observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) continue;
        observer.unobserve(entries[i].target);
        self.show(entries[i].target);
      }
    }, { rootMargin: '0px 0px ' + (-offset) + 'px 0px', threshold: 0 });
    this.observers[offset] = observer;
    return observer;
  };

  WOW.prototype.show = function (box) {
    this.applyStyle(box, false);
    box.className = box.className + ' ' + this.config.animateClass;
    if (this.config.callback != null) this.config.callback(box);
    var evt;
    try { evt = new CustomEvent(this.config.boxClass); }
    catch (e) { evt = document.createEvent('CustomEvent'); evt.initCustomEvent(this.config.boxClass, false, false, null); }
    box.dispatchEvent(evt);
    box.addEventListener('animationend', this.resetAnimation);
    box.addEventListener('webkitAnimationEnd', this.resetAnimation);
    return box;
  };

  WOW.prototype.resetAnimation = function (event) {
    if (event.type.toLowerCase().indexOf('animationend') >= 0) {
      var target = event.target || event.srcElement;
      target.className = target.className.replace(this.config.animateClass, '').trim();
    }
  };

  WOW.prototype.applyStyle = function (box, hidden) {
    var self = this;
    var duration = box.getAttribute('data-wow-duration');
    var delay = box.getAttribute('data-wow-delay');
    var iteration = box.getAttribute('data-wow-iteration');
    raf(function () { self.customStyle(box, hidden, duration, delay, iteration); });
  };

  WOW.prototype.customStyle = function (box, hidden, duration, delay, iteration) {
    if (hidden) this.cacheAnimationName(box);
    box.style.visibility = hidden ? 'hidden' : 'visible';
    if (duration) box.style.animationDuration = duration;
    if (delay) box.style.animationDelay = delay;
    if (iteration) box.style.animationIterationCount = iteration;
    box.style.animationName = hidden ? 'none' : this.cachedAnimationName(box);
    return box;
  };

  WOW.prototype.cacheAnimationName = function (box) {
    var name = window.getComputedStyle(box).getPropertyValue('animation-name');
    name = name === 'none' ? '' : name;
    if (this.names) this.names.set(box, name); else box.__bslWowName = name;
  };

  WOW.prototype.cachedAnimationName = function (box) {
    var name = this.names ? this.names.get(box) : box.__bslWowName;
    return name || '';
  };

  window.WOW = WOW;
})(window, document);
